<div class="row">
	<div class="col-sm-12">
		<div class="card-box clearfix {{color_class}}">
			<h3 id='ct-{{titleID}}-heading'>{{title}}</h3>
			<p>{{{text}}}</p>
			{{#if action_label}}
			<a href="#" class="btn btn-primary m-t-30" id="js-action">{{action_label}}</a>
			{{/if}}
			{{#if action_label_2}}
			<a href="#" class="btn btn-primary m-t-30" id="js-action-2">{{action_label_2}}</a>
			{{/if}}
		</div>
	</div>
</div>
